import "./styles.css";
import { initRouter } from "./router.js";

/* -------------------------------------------------------------
   Mobile nav toggle
   ------------------------------------------------------------- */
const nav = document.querySelector(".nav");
const toggle = document.querySelector(".nav-toggle");
if (toggle && nav) {
  toggle.addEventListener("click", () => {
    const open = nav.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
  nav.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => {
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    })
  );
}

/* -------------------------------------------------------------
   Router — each page is a separate module, lazily loaded the
   first time its route is visited (see src/router.js).
   ------------------------------------------------------------- */
initRouter(document.getElementById("app"));
